import { Controller } from "@hotwired/stimulus"
import Chartkick from "chartkick"
import Chart from "chart.js/auto"
import "chartjs-adapter-date-fns"

Chartkick.use(Chart)

export default class extends Controller {
  static targets = ["budgetContainer", "timelineContainer"]

  connect() {
    this.projectId = this.element.dataset.projectId
    this.loadCharts()
  }

  loadCharts() {
    this.loadChart(`/projects/${this.projectId}/budget_progression`, this.budgetContainerTarget, { responsive: true, maintainAspectRatio: false })

    const timelineOptions = {
      responsive: true,
      maintainAspectRatio: false,
      points: false,
      min: 0,
      max: 100,
      ytitle: 'Completion %',
      curve: true,
      library: {
        scales: {
          y: {
            ticks: {
              callback: (value) => `${value}%`
            }
          }
        },
        elements: {
          line: {
            tension: 0.2
          }
        }
      }
    }
    this.loadChart(`/projects/${this.projectId}/timeline_progression`, this.timelineContainerTarget, timelineOptions)
  }

  loadChart(url, element, options = {}) {
    fetch(url, { headers: { 'Accept': 'application/json' }})
      .then(r => r.json())
      .then(series => {
        new Chartkick.LineChart(element, series, options)
      })
  }
}
